module.exports = __webpack_public_path__ + "4cfb254756b28ece61b3cc4360063762.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/img/proyect-selected/modulo-noticias.jpg
 ** module id = 443
 ** module chunks = 8
 **/